import { useMemo } from "react";
import { Store, Settings2, CheckCircle2 } from "lucide-react";
import { teamSummaries, SAHA_HESAPLARI, formatTRY, formatInt } from "../data/mock";

export default function BayiYonetimi() {
  const teams = useMemo(() => teamSummaries({}), []);

  return (
    <div className="space-y-5" data-testid="page-bayi-yonetimi">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <Store className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Bayi Yönetimi</h1>
          <p className="text-xs text-slate-500">Bayi tanımları, minimum yatırım ve durum yönetimi</p>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">BAYİ KODU</th>
                <th className="px-4 py-3">MİN. YATIRIM</th>
                <th className="px-4 py-3 text-right">HESAP</th>
                <th className="px-4 py-3 text-right">TOPLAM YATIRIM</th>
                <th className="px-4 py-3 text-right">İŞLEM</th>
                <th className="px-4 py-3">DURUM</th>
                <th className="px-6 py-3 text-right">İŞLEM</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {teams.map((t) => (
                <tr key={t.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50" data-testid="bayi-row">
                  <td className="px-6 py-3 font-bold flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full" style={{ background: t.color }} />{t.name}</td>
                  <td className="px-4 py-3"><span className="font-semibold" style={{ color: t.color }}>{t.minLabel}</span></td>
                  <td className="px-4 py-3 text-right">{SAHA_HESAPLARI.filter((h) => h.bayiId === t.id).length}</td>
                  <td className="px-4 py-3 text-right font-bold text-green-600">{formatTRY(t.yatirim)}</td>
                  <td className="px-4 py-3 text-right font-semibold">{formatInt(t.adet)}</td>
                  <td className="px-4 py-3"><span className="inline-flex items-center gap-1 text-green-600 font-semibold text-xs"><CheckCircle2 size={14} /> Aktif</span></td>
                  <td className="px-6 py-3 text-right">
                    <button className="inline-flex items-center gap-1.5 rounded-lg border border-slate-300 dark:border-slate-700 px-3 py-1.5 text-xs font-semibold hover:bg-slate-50 dark:hover:bg-slate-800"><Settings2 size={13} /> Düzenle</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
